module.exports = __webpack_public_path__ + "img/DS820(8x12)LX_Metallic.d666c14f.jpg";